import { render, staticRenderFns } from "./EfsMdGroupPriceListForm.vue?vue&type=template&id=36ff2b64&"
import script from "./EfsMdGroupPriceListForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdGroupPriceListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports